import { IToolbarItem } from "./IToolbarItem";
import { ToolbarDropdown } from "./ToolbarDropdown";
import { Toolbar } from "../Toolbar";

export class ToolbarDropdownItem implements IToolbarItem {
    public value: string;
    public id: string;

    public constructor(private control: HTMLElement, private dropdown: ToolbarDropdown, private toolbar: Toolbar) {
        if (control.hasAttribute("data-value")) {
            this.value = control.getAttribute("data-value");
            control.addEventListener("click", () => {
                toolbar.dispatchDropDownClick(dropdown, this.value);
                this.select();
            });
        }
        if (control.hasAttribute("data-id")) {
            this.id = control.getAttribute("data-id");
        }
    }

    public select() {
        let text = this.control.innerText;
        this.dropdown.selectItem(text, this.value);
    }

    public enable(enable: boolean) {
        if (enable) {
            this.control.classList.remove("disabled");
        }
        else {
            this.control.classList.add("disabled");
        }
    }
}
